import jQuery from 'jquery';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import CustomAnimation from '../animation/customAnimation';
import Splide from '@splidejs/splide';

let splide1;
const customAnmation = new CustomAnimation();

function showMonthyPrice() {
  jQuery('.button_monthly').removeClass('button_red');
  jQuery('.button_monthly').addClass('deactive');
  jQuery('.button_yearly').addClass('button_red');
  jQuery('.button_yearly').removeClass('deactive');

  // change price
  let dataMonthlyStarterd01 = jQuery('.pricing_box_starter').data('monthly-01');
  let dataMonthlyStandard01 = jQuery('.pricing_box_standard').data('monthly-01');
  let dataMonthlyPro01 = jQuery('.pricing_box_pro').data('monthly-01');

  jQuery('.price_text_starter_01').html(dataMonthlyStarterd01);
  jQuery('.price_text_standard_01').html(dataMonthlyStandard01);
  jQuery('.price_text_pro_01').html(dataMonthlyPro01);

  let starterdUrl = jQuery('.pricing_box_starter').data('monthly-url');
  let standardUrl = jQuery('.pricing_box_standard').data('monthly-url');
  let proUrl = jQuery('.pricing_box_pro').data('monthly-url');
  jQuery('.button_starter').attr('href', starterdUrl);
  jQuery('.button_standard').attr('href', standardUrl);
  jQuery('.button_pro').attr('href', proUrl);

}

function showMYearlyPrice() {
  jQuery('.button_yearly').removeClass('button_red');
  jQuery('.button_yearly').addClass('deactive');

  jQuery('.button_monthly').addClass('button_red');
  jQuery('.button_monthly').removeClass('deactive');

  // change price
  let dataYearlyStarter01 = jQuery('.pricing_box_starter').data('yearly-01');
  let dataYearlyStandard01 = jQuery('.pricing_box_standard').data('yearly-01');
  let dataYearlyPro01 = jQuery('.pricing_box_pro').data('yearly-01');

  jQuery('.price_text_starter_01').html(dataYearlyStarter01);
  jQuery('.price_text_standard_01').html(dataYearlyStandard01);
  jQuery('.price_text_pro_01').html(dataYearlyPro01);

  let starterUrl = jQuery('.pricing_box_starter').data('yearly-url');
  let standardUrl = jQuery('.pricing_box_standard').data('yearly-url');
  let proUrl = jQuery('.pricing_box_pro').data('yearly-url');
  jQuery('.button_starter').attr('href', starterUrl);
  jQuery('.button_standard').attr('href', standardUrl);
  jQuery('.button_pro').attr('href', proUrl);

}

class Pricing {
  init() {
    this.initPage();
    this.initParallax();
    this.initlistener();
    this.onScroll();
  }

  initPage = () => {
    splide1 = new Splide( '.splide_01', {
      type: 'loop',
      perPage: 1,
      focus: 'center',
      autoplay: false,
      //interval: 8000,
      flickMaxPages: 3,
      updateOnMove: true,
      pagination: true,
      //padding: '20%',
      throttle: 300,
    } );
    splide1.mount();

    // backgrounds
    jQuery('.header_background').css("background-image", "url("+ jQuery('.header_background').data('bg-image') +")");
    jQuery('.pricing_boxes_background').css("background-image", "url("+ jQuery('.pricing_boxes_background').data('bg-image') +")");
    jQuery('.pricing_table_background').css("background-image", "url("+ jQuery('.pricing_table_background').data('bg-image') +")");

    showMYearlyPrice();
  }

  initParallax = () => {
    gsap.registerPlugin(ScrollTrigger);

    customAnmation.animateHeaderImage('.header_background');
    customAnmation.animateBgImage('.pricing_boxes_background', '.pricing_boxes')
    customAnmation.animateBgImage('.pricing_table_background', '.pricing_boxes')
    customAnmation.animateText('.pricing_boxes_text');
    //customAnmation.animateButtonHolder('.button_holder_pricing_table');
    customAnmation.animateGroup('.pricing_boxes');
  }

  initlistener = () => {
    jQuery('.button_monthly').click(function(e) {
      e.preventDefault();
      showMonthyPrice();
    });
    jQuery('.button_yearly').click(function(e) {
      e.preventDefault();
      showMYearlyPrice();
    });

    jQuery('.price_toggle_button').click(function() {
      let toggled = jQuery('.price_toggle_button_highlight', jQuery(this)).hasClass('toggle');

      if(toggled == false) {
        // monthly
        jQuery('.price_toggle_button_highlight', jQuery(this)).addClass('toggle');
        jQuery('.left .button_label_holder', jQuery(this) ).removeClass('hightlight');
        jQuery('.right .button_label_holder', jQuery(this) ).addClass('hightlight');

        showMonthyPrice();
      }
      else {
        // yearly
        jQuery('.price_toggle_button_highlight', jQuery(this)).removeClass('toggle');
        jQuery('.left .button_label_holder', jQuery(this) ).addClass('hightlight');
        jQuery('.right .button_label_holder', jQuery(this) ).removeClass('hightlight');

        showMYearlyPrice();
      }
    });
}


  onScroll = () => {

  };
}

export default Pricing;
